import { getLocaleDirection } from '@angular/common';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Remove # symbol for bookmarked urls since we have switched from 
// HashLocationStrategy to PathLocationStrategy
let url = location.href;
let startOfUrl = location.protocol + '//' + location.hostname + (location.port !== "" ? ":" + location.port : '');
if(url.substring(startOfUrl.length).startsWith('/#'))
{
  location.replace(startOfUrl + url.substring(startOfUrl.length + 2));
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
